import React, { useEffect, useState } from "react";
import CreateBundle from "../Teachers/CreateCourse/CreateBundle";
import AnnouncementCard from "./AnnouncementCard";
import { getPaymentBaseurl } from "../../../_helpers";
import axiosInstance from "../../../axios";
import { Loading } from "../../Other/Loading";
import OverlayContainer from "../../Overlay/OverlayContainer";
import { annnouncementOptionData } from "../../../_constants/staticData";
import "./announcement.scss";

const ApiBaseUrl = getPaymentBaseurl(window?.location?.href,true);
export default function Announcement() {
  const [current, setcurrent] = useState(0);
  const [payload, setPayload] = useState({
    name: "",
    description: "",
    data: [],
  });
  const [selectAnnounceCourse, setSelectAnnounceCourse] = useState();
  const [success, setSuccess] = useState(false);
  const [load, setload] = useState(false);
  const [announceData, setAnnounceData] = useState([]);
  const [deleteModal, setDeleteModal] = useState({
    modal: false,
    id: null,
    index: null,
  });

  const handleChange = (e) => {
    const value = e.target.value;
    var date = new Date();
    var getExpirationDate = date.setDate(date.getDate() + 10);
    setPayload((prev) => {
      return {
        ...prev,
        data: selectAnnounceCourse.map((ele) => ({
          courseId: ele.ID,
          activationDate: new Date(),
          expirationDate: new Date(getExpirationDate),
        })),
        description: value,
        name: "edusity annoucement testing two",
      };
    });
  };

  const handleClick = () => {
    axiosInstance
      .post(`${ApiBaseUrl}/announcement`, payload)
      .then((res) => {
        if (!res.error) {
          setSuccess(true);
          setcurrent(0);
        }
      })
      .catch((res) => {
        console.log(res);
      });
  };

  const fetch = () => {
    setload(true);
    axiosInstance
      .get(`${ApiBaseUrl}/v2/announcement`)
      .then((res) => {
        if (!res.data.error) {
          setload(false);
          setAnnounceData(res.data.data);
        }
      })
      .catch((res) => {
        console.log(res);
        setload(false);
      });
  };

  useEffect(() => {
    if (current === 0) {
      fetch();
    }
  }, [current]);

  const accouncementActionHandler = (status, element) => {
    if (status === "create") {
      setcurrent(current + 1);
      setSelectAnnounceCourse();
      setPayload({
        name: "",
        description: "",
        data: [],
      });
    } else if (element?.id) {
      setSelectAnnounceCourse(element.courses);
      setPayload({
        ...payload,
        description: status,
        update: true,
        updateId: element?.id,
      });
      setcurrent(current + 1);
    }
  };

  const updateHandlerAnnouncement = () => {
    var date = new Date();
    var getExpirationDate = date.setDate(date.getDate() + 10);
    axiosInstance
      .put(
        `${ApiBaseUrl}/announcement/${payload?.updateId}`,
        {
          name: "demo",
          description: payload.description,
          data:
            selectAnnounceCourse &&
            selectAnnounceCourse.length > 0 &&
            selectAnnounceCourse.map((item) => ({
              courseId: item.courseId || item.ID,
              activationDate: new Date(),
              expirationDate: new Date(getExpirationDate),
            })),
        }
      )
      .then((res) => {
        if (!res.data.error) {
          setSuccess(true);
          setcurrent(0);
          setPayload({
            courses: [],
            description: "",
          });
          setSelectAnnounceCourse();
        }
      })
      .catch((res) => console.log(res));
  };
  return (
    <div className="container-wrapper">
      {current === 0 && (
        <section>
          <h3> Active Announcements</h3>
          {load ? (
            <Loading />
          ) : (
            <>
              {announceData?.length === 0 && (
                <div className="no-announcement-found">
                  <span className="recordNotFound">No Announcement Found</span>
                </div>
              )}
              {announceData?.map((ele) => {
                return (
                  <>
                    <AnnouncementCard
                      element={ele}
                      deleteModal={deleteModal}
                      setDeleteModal={setDeleteModal}
                      accouncementActionHandler={accouncementActionHandler}
                      fetchAnnouncements={fetch}
                    />
                  </>
                );
              })}
            </>
          )}
        </section>
      )}

      {current == 0 && (
        <div>
          <button
            className="new_ann_btn announcement-btn sm"
            onClick={() => accouncementActionHandler("create")}
            disabled={current === 0 ? false : true}
          >
            Create new Announcement
          </button>
        </div>
      )}

      {current === 1 && (
        <div>
          {selectAnnounceCourse && selectAnnounceCourse.length > 0 && (
            <button className="btn-next-new" onClick={() => setcurrent(2)}>
              Next
            </button>
          )}
          <button
            className="btn-announce-back mt-5"
            onClick={() => setcurrent(current - 1)}
          >
            Back
          </button>

          <CreateBundle
            announcement={true}
            setSelectAnnounceCourse={setSelectAnnounceCourse}
            selectAnnounceCourse={selectAnnounceCourse}
            setAnnounceData={setAnnounceData}
          />
        </div>
      )}

      {current === 2 && (
        <div className="margin-accouncement">
          <p className="choose-announcement">
            Choose your Announcement course for the following.
          </p>
          {selectAnnounceCourse &&
            selectAnnounceCourse.length > 0 &&
            selectAnnounceCourse.map((ele, index) => (
              <div
                key={index}
                className="border-bottom-courseBundle"
                style={{
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <div className="main-conatiner-course-bundle">
                  <div>
                    <h4 className="bundle-Section-1">{ele.CourseName}</h4>
                    <div className="courseSelected-flex">
                      <div>{ele?.Category} </div>
                      <p style={{ marginLeft: ele?.Category ? "10px" : "0px" }}>
                        <strong className="str">Duration: </strong>
                        {ele.Duration
                          ? "Duration Not found"
                          : ` ${ele.Duration} hrs`}
                      </p>
                      <p>
                        <strong className="str">Language: </strong>
                        {ele.Language}
                      </p>
                      <p>
                        <strong className="str">Subtitles: </strong>
                        English
                      </p>
                    </div>
                  </div>
                  <div>
                    <img
                      src="https://cdn.edusity.com/icons/icon-complete-check.svg"
                      width={"20px"}
                    />
                  </div>
                </div>
              </div>
            ))}

          <div className="announc-category">
            <div className="announce-category-item">
              <select
                onChange={(e) => handleChange(e)}
                value={payload.description}
              >
                <option hidden style={{ marginTop: "10px" }}>
                  Choose your Announcement
                </option>
                {annnouncementOptionData.map((option) => {
                  return (
                    <option
                      style={{ marginTop: "100px" }}
                      className="option-announce"
                      value={option.text}
                      selected={payload.description === option.text}
                    >
                      {option.text}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="btn-accounce-main">
              <button
                className="btn-announce-back mt-5"
                onClick={() => setcurrent(current - 1)}
              >
                Back
              </button>
              <button
                className="btn-announce"
                onClick={
                  payload?.update ? updateHandlerAnnouncement : handleClick
                }
              >
                {payload?.update ? "Update Announce" : "Announce"}
              </button>
            </div>
          </div>
        </div>
      )}

      {success && (
        <OverlayContainer>
          <div className="alert-title-1">
            <div className="icon-wrapper">
              <img
                src="https://cdn.edusity.com/icons/icon-complete-check.svg"
                alt="check-complete"
              />
            </div>
            <div className="status-message">
              <div className="status-title">
                <p>Announcement successfully created!</p>
              </div>
            </div>
            <div className="margin-top-new-01-0">
              <button
                className="lastmonth-btn-0"
                onClick={() => setSuccess(false)}
              >
                Close
              </button>
            </div>
          </div>
        </OverlayContainer>
      )}
    </div>
  );
}
